import React, { KeyboardEventHandler } from "react";
import clsx from "clsx";
import queryString from "query-string";
import { connect } from "react-redux";
import { FC } from "react";
import { loadPdfDoc } from "../../services/PdfDocumentService";
import { mergeStyles } from "office-ui-fabric-react";
import { mergeStyleSets } from "office-ui-fabric-react";
import { State } from "../../store";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { useRef } from "react";
import { useState } from "react";
import {
  MODALITY,
  WorkPacket,
  WorkPacketDocument,
  WorkPacketLayout,
} from "../../models/WorkPacket";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as WorkPacketStore from "../../store/WorkPacketStore";
import * as TruckNominationStore from "../../store/TruckNominationStore";
import Modal from "../common/Modal";
import { Option } from "../../models/Option";
import Email from "../common/Email";
import {
  EmailWorkPacketsRequest,
  OtherOption,
} from "../../models/EmailWorkPacketsRequest";
import moment from "moment";
import { emailApi } from "../../api/emailApi";
import SofIcon from "../common/Icons";

type IProps = LineHandlingStore.LineHandlingState &
  WorkPacketStore.WorkPacketState &
  TruckNominationStore.TruckNominationState;

const classes = mergeStyleSets({
  formContainer: { display: "flex", flexDirection: "column", height: "100%" },
  formHeader: {
    gap: 8,
    padding: 16,
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
  },
  formHeaderTitle: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "24px",
    letterSpacing: "0.005em",
    color: "#4C4C4C",
  },
  toolbarSeparator: {
    height: "40px",
    width: "1px",
    background: "#D8DFE6",
    margin: "0",
  },
  iframe: {
    width: "100%",
    height: "unset !important",
    background: "white",
  },
  printContainer: {
    flexGrow: 1,
    overflow: "auto",
    display: "flex",
  },
  formFooter: {
    position: "absolute",
    bottom: 15,
    padding: 16,
    backgroundColor: "white",
    alignItems: "center",
  },
  sendButton: {
    padding: "8px 36px",
    backgroundColor: "#009FDF",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2,
  },
  errorButton: {
    padding: "8px 36px",
    backgroundColor: "red",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2,
  },
  modalEmail: {
    width: "100%",
    height: "100%",
    border: "0",
    boxShadow: "0 0 1em rgb(0 0 0 /.3)",
  },
  modalContainer: {
    display: "flex",
    height: "91vh",
  },
  modalPdfPreviewContainer: {
    flex: 1,
  },
  modalRightPanelContainer: {
    width: "25%",
  },
  modalComponent: {
    paddingRight: 16,
    paddingLeft: 16,
  },
  modalSelectedItemWrapper: {
    paddingTop: 16,
    display: "flex",
    flexDirection: "column",
  },
  modalSelectedItem: {
    paddingLeft: 10,
  },
});
const buttonIcon = mergeStyles({
  width: "48px",
  height: "48px",
  border: "1px solid var(--grey-200)",
  background: "var(--grey-050)",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  selectors: {
    ":hover": {
      backgroundColor: "#EEEEEE",
      textDecoration: "none",
    },
  },
});

const PrintPreview: FC<IProps> = (props: IProps) => {
  const { lineHandlingNo, workPacketId } = useParams() as any;
  const [nominationNo, setNominationNo] = useState<string>();
  const [documentId, setDocumentId] = useState<number>();
  const [wpDocument, setWPDocument] = useState<WorkPacketDocument>();
  const [workPacket, setWorkPacket] = useState<WorkPacket>();
  const [pdfContentBlob, setPdfContentBlob] = useState<Blob>();
  const [pdfContent, setPdfContent] = useState<string>();
  const [emailAddresses, setEmailAddresses] = useState<readonly Option[]>([]);
  const [emailStatus, setEmailStatus] = useState<string>("default");
  const [modality, setModality] = useState<MODALITY>("MARINE");
  const history = useHistory();
  const pageRef = useRef<HTMLIFrameElement>(null);

  const modalities = {
    MARINE: 0,
    TRUCK: 1,
    RAIL: 2,
  };

  const onClose = () => {
    var params = "";
    if (workPacket && workPacket.forms.length > 0) {
      if (workPacket.level === 2) {
        params = "?nomination=" + nominationNo;
      }
    }

    if (documentId) {
      params += (params.length > 0 ? "&" : "?") + "documentId=" + documentId;
    }
    if (workPacket && workPacket.forms.length > 0) {
      history.push(
        `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packet/${workPacketId}${params}`
      );
    } else {
      history.push(
        `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packets`
      );
    }
  };

  const printDoc = () => {
    var iframe = document.getElementById("print-window") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.focus();
      iframe.contentWindow.print();
    }
  };

  const contentOnLoad = () => {
    var iframe = document.getElementById("print-window") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.style.height =
        iframe.contentWindow.document.body.scrollHeight + 199 + "px";
    }
  };

  const loadPdf = async (layout: WorkPacketLayout) => {
    const pdfDoc = await loadPdfDoc(
      layout.pdfFile,
      lineHandlingNo,
      nominationNo === "undefined" ? undefined : nominationNo,
      documentId,
      props.lineHandling,
      props.workPacketValues,
      props?.truckNomination?.result
    );
    if (pdfDoc) {
      const pdfBytes = await pdfDoc.save({});
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      setPdfContentBlob(blob);
      const docUrl = URL.createObjectURL(blob);
      setPdfContent(docUrl);
    }
  };

  useEffect(() => {
    if (workPacket) {
      const layout = workPacket.layouts[0];
      loadPdf(layout);
    }
  }, [workPacket]);

  useEffect(() => {
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const nominationno = q.nomination as string | undefined;
    setNominationNo(nominationno);

    const documentid = q.documentid as string | undefined;
    if (documentid) setDocumentId(parseInt(documentid));
    if (documentid && props.workPacketDocuments.result) {
      const wpDocument = props.workPacketDocuments.result.find(
        (f) => f.id === parseInt(documentid)
      );
      setWPDocument(wpDocument);
    }

    if (history.location.pathname.indexOf("marine") >= 0) {
      setModality("MARINE");
    } else if (history.location.pathname.indexOf("truck") >= 0) {
      setModality("TRUCK");
    } else if (history.location.pathname.indexOf("rail") >= 0) {
      setModality("RAIL");
    }

    if (workPacketId && props.workPackets.result) {
      const workpacket = props.workPackets.result.find(
        (f) => f.id === parseInt(workPacketId, 10)
      );
      if (workpacket) {
        setWorkPacket(workpacket);
      }
    } else {
      onClose();
    }
  }, []);

  const sendEmailModal = async () => {
    setEmailAddresses([]);
    setEmailStatus("default");

    if (workPacket) {
      const layout = workPacket.layouts[0];
      loadPdf(layout);
    }

    const modal = document.getElementById(
      "sendemail-modal"
    ) as HTMLDialogElement;
    modal.showModal();
  };

  const blobToBase64 = (blob: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  const closeEmailModal = () => {
    const modal = document.getElementById(
      "sendemail-modal"
    ) as HTMLDialogElement;
    modal.close();
  };

  const sendEmail = async () => {
    if (pdfContent === undefined) return;

    setEmailStatus("sending");

    const result = (await blobToBase64(pdfContentBlob)) as string;

    const array = result?.split(",");
    const base64 = array.length > 0 ? array[1] : "";

    const workPackets = [workPacket?.name];

    const currentDate = moment().format("YYYYMMDD-HHmm");

    let otherOptions: OtherOption[] = [];

    if (modality === "TRUCK" || modality === "RAIL") {
      otherOptions = [{ key: "nominationNo", value: lineHandlingNo }];
    }

    const attachmentRequest = {
      recipients: emailAddresses.map((a: { value: string }) => a.value),
      vesselName: props.lineHandling.result?.vesselName,
      attachments: [
        {
          content: base64,
          fileName: `workpackets-${currentDate}.pdf`,
          mimeType: "application/pdf",
        },
      ],
      workpackets: workPackets,
      status: props.lineHandling.result?.status,
      modality: modalities[modality],
      otherOptions: otherOptions,
    } as EmailWorkPacketsRequest;

    const emailResponse = await emailApi.sendEmailWorkPacketsAsync(
      attachmentRequest
    );

    if (emailResponse.emailStatus) {
      setEmailStatus("success");

      setTimeout(function () {
        const modal = document.getElementById(
          "sendemail-modal"
        ) as HTMLDialogElement;
        modal.close();
      }, 3000);
    } else {
      setEmailStatus("error");
    }
  };

  return (
    <div className={classes.formContainer}>
      {workPacket && (
        <>
          <div className={classes.formHeader}>
            <span className={classes.formHeaderTitle}>
              {wpDocument?.name ?? workPacket.name}
            </span>
            <div style={{ flexGrow: 1 }}></div>
            <button
              id="btn-download"
              type="button"
              className={buttonIcon}
              onClick={sendEmailModal}
            >
              <SofIcon iconname="Mail" />
            </button>
            <button
              id="btn-print"
              type="button"
              className={buttonIcon}
              onClick={printDoc}
            >
              <SofIcon iconname="Print" />
            </button>
            <div className={classes.toolbarSeparator}></div>
            <button
              id="btn-close"
              type="button"
              className={buttonIcon}
              onClick={onClose}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
              >
                <path
                  d="M0.589143 0.715991L0.646143 0.645991C0.728999 0.563315 0.838234 0.512329 0.954817 0.501913C1.0714 0.491497 1.18794 0.522313 1.28414 0.588991L1.35414 0.645991L6.00014 5.29299L10.6461 0.645991C10.74 0.552104 10.8674 0.499359 11.0001 0.499359C11.1329 0.499359 11.2603 0.552104 11.3541 0.645991C11.448 0.739877 11.5008 0.867215 11.5008 0.999991C11.5008 1.13277 11.448 1.2601 11.3541 1.35399L6.70714 5.99999L11.3541 10.646C11.4368 10.7288 11.4878 10.8381 11.4982 10.9547C11.5086 11.0712 11.4778 11.1878 11.4111 11.284L11.3541 11.354C11.2713 11.4367 11.1621 11.4877 11.0455 11.4981C10.9289 11.5085 10.8123 11.4777 10.7161 11.411L10.6461 11.354L6.00014 6.70699L1.35414 11.354C1.26026 11.4479 1.13292 11.5006 1.00014 11.5006C0.867368 11.5006 0.74003 11.4479 0.646143 11.354C0.552257 11.2601 0.499512 11.1328 0.499512 11C0.499512 10.8672 0.552257 10.7399 0.646143 10.646L5.29314 5.99999L0.646143 1.35399C0.563468 1.27114 0.512481 1.1619 0.502066 1.04532C0.49165 0.928733 0.522465 0.81219 0.589143 0.715991Z"
                  fill="#4C4C4C"
                />
              </svg>
            </button>
          </div>
          <div
            id={`dwp-1`}
            className={clsx(classes.printContainer, "custom-scroll")}
          >
            <iframe
              ref={pageRef}
              id="print-window"
              scrolling="no"
              frameBorder={0}
              src={pdfContent !== undefined ? `${pdfContent}#toolbar=0` : ""}
              onLoad={contentOnLoad}
              className={classes.iframe}
            />
          </div>
          <div>
            <Modal
              id="sendemail-modal"
              title="Send Work Packets"
              className={classes.modalEmail}
              showModalHeader={false}
            >
              <Email
                id="email"
                pdfSrc={pdfContent}
                emailStatus={emailStatus}
                emailAddresses={emailAddresses}
                setEmailAddresses={setEmailAddresses}
                closeEmailModal={closeEmailModal}
                sendEmail={sendEmail}
                workPacketDisplayName={workPacket?.name}
              ></Email>
            </Modal>
          </div>
        </>
      )}
    </div>
  );
};
export default connect((state: State) => ({
  ...state.lineHandling,
  ...state.workPacket,
  ...state.truckNomination,
}))(PrintPreview);
